"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StorageLocation = void 0;
var StorageLocation;
(function (StorageLocation) {
    StorageLocation["Local"] = "local";
    StorageLocation["Session"] = "session";
    StorageLocation["Memory"] = "memory";
    StorageLocation["Cookie"] = "cookie";
})(StorageLocation || (exports.StorageLocation = StorageLocation = {}));
//# sourceMappingURL=constants.js.map